import { read } from 'gso-session';
import api from 'gso-fetch';
import { fetchme } from 'gso-fetchme';
import { getEntrypoint } from 'gso-get-entrypoint';
import parseJwt from 'gso-jwt';
const BASE_URL = '/api/legacy/petrus/bijster';
async function getApplications() {
    const jwt = parseJwt(read('token'));
    const entrypoint = await getEntrypoint(jwt ? 'user-server' : 'petrus');
    const applications = await fetchme(entrypoint.links.application);
    return jwt ? applications : applications.items;
}
async function loadBijster() {
    return api
        .url(BASE_URL)
        .get()
        .json();
}
export { getApplications, loadBijster };
//# sourceMappingURL=user-proxy.js.map